/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import VisGraph, {
  GraphData,
  GraphEvents,
  Options,
} from 'react-vis-graph-wrapper';
import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useRef, memo, useMemo } from 'react';

// c.desc, c.parent_id, c.id
function ProbeHierarchy({ children } : { children: any[] }) {
    const theme : any = useTheme();
    const navigate = useNavigate();
    const networkRef = useRef<any>(null);
    if (!children || children.length === 0) {
        return <div></div>;
    }
    let rootId = children[0].id;
    children.forEach(c => {
        if (c.id < rootId) {
            rootId = c.id;
        }
    });
    function nodeColor(c: any) {
        const { id, passed, pending, running } = c;
        if (running) {
            return theme.colors.nodeRunning;
        }
        if (id === rootId) {
            return theme.colors.nodeRoot;
        }
        if (pending) {
            return theme.colors.nodePending;
        }
        return passed ? theme.colors.nodeGood : theme.colors.nodeBad;
    }
    const g9 : GraphData = {
        nodes: children.map(c => ({
            id: c.id,
            label: `${c.title || c.desc}\n${c.op_name || ''} #${c.id}`,
            title: `ID: ${c.id}\nParent ID: ${c.parent_id}\nDescription: ${c.title || c.desc} c.passed: ${c.passed}\npending: ${c.pending}`,
            font: {
                color: nodeColor(c)
            },
            color: {
                background: theme.colors.bg,
                border: nodeColor(c),
                highlight: {
                    background: theme.colors.bg,
                    border: nodeColor(c),
                },
                hover: {
                    background: theme.colors.bg,
                    border: nodeColor(c)
                }
            }
        })),
        edges: children.filter(c => c.parent_id)
                    .map(c => ({
                            from: c.parent_id,
                            to: c.id,
                    })),
    };
    const events: GraphEvents = {
        select: (event: any) => {
            const { nodes, edges } = event;
            if (nodes.length > 0) {
                const probeId = nodes[0];
                if (probeId != 'N/A') {
                    navigate(`/probe/${probeId}`);
                }
            }
        },
    }
    const options = {
        layout: {
        },
        physics: {
            enabled: true,
            barnesHut: {
                gravitationalConstant: -7000,
//                avoidOverlap: 0.1,
            },
        },
        edges: {
            color: theme.colors.ctext,
//            length: 100,
        },
        interaction: {
            tooltipDelay: 1000,
        },
        nodes: {
            shape: 'box',
        }
    };
    return <VisGraph key="vg1" graph={g9} options={options} events={events} 
        ref={(network) => {
                networkRef.current = network;
                if (networkRef.current) {
                    networkRef.current.moveTo({
                        scale: 0.3,
                        position: { x: 0, y: 0 }
                    });
                    networkRef.current.once('stabilized', () => {
                        networkRef.current.fit();
                    });
                }
            }} 
        />
}

function areEqual(prevProps: any, nextProps: any) {
    let rc = JSON.stringify(prevProps) === JSON.stringify(nextProps);
    return rc;
}

export default memo(ProbeHierarchy, areEqual);
/*

    */